import React from "react";
import ResultManager from "./ResultManager";

export const ManageResult = () => <ResultManager title="Manage Result" />;

export const ManagePrevious = () => <ResultManager title="Previous Result" />;
